import { ButtonDS, CheckOutlined, InputDS } from "@qivia/ui";
import { useAppDispatch } from "../../../redux/hooks";
import styled from "styled-components";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { createCompanyAcronymAsync } from "../followUpSlice";
import "../../../i18n/i18n";

type AcronymInputProps = {
  companyUuid: string;
  isAcronymValid: (input: string) => boolean;
};

export const AcronymInput = (props: AcronymInputProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [newAcronym, setNewAcronym] = useState<string>();

  const clickToSubmit = useCallback(() => {
    if (!newAcronym) return;
    props.isAcronymValid(newAcronym) &&
      void dispatch(
        createCompanyAcronymAsync({
          companyUuid: props.companyUuid,
          acronym: newAcronym,
        }),
      );
  }, [dispatch, newAcronym, props]);

  return (
    <StyledRow>
      <InputDS
        error={
          newAcronym && !props.isAcronymValid(newAcronym)
            ? t("companyFollowUp.acronym.input.error")
            : undefined
        }
        placeholder={t("companyFollowUp.acronym.input.placeholder")}
        value={newAcronym}
        onKeyDown={(e) => e.key === "Enter" && clickToSubmit()}
        onChange={(e) => setNewAcronym(e.target.value)}
        withoutSpacerBottom
      />
      <ButtonDS
        singleIcon={{ icon: <CheckOutlined />, size: "S" }}
        format="fill"
        buttonType="primary"
        onClick={clickToSubmit}
      />
    </StyledRow>
  );
};

const StyledRow = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;
